import {
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import React, { useContext } from "react"
import CloudinaryVideoUpload from "~/components/Common/CloudinaryVideoUpload"
import CounterHeader from "~/components/Common/CounterHeader"
import ThumbnailUpload from "~/components/Common/ThumbnailUpload"
import ClientContext from "~/contexts/Client"
import Box from "../../Common/Box"
import useStyles from "./styles"

const DashboardLeftSide = () => {
  const classes = useStyles()
  const theme = useTheme()
  const phoneView = useMediaQuery(theme.breakpoints.down("sm"))

  const { clientDetailsValues, setClientDetailsValues } =
    useContext(ClientContext)

  const getUploadData = (data) => {
    return JSON.stringify({
      url: data.url,
      secure_url: data.secure_url,
      original_filename: data.original_filename,
      version: data.version,
      format: data.format,
      public_id: data.public_id,
    })
  }

  const renderDashboardVisible = () => {
    return (
      <Box>
        <Typography color="secondary" className={classes.inputLabel}>
          Dashboard Visible
        </Typography>
        <FormControlLabel
          label="Show client dashboard in menu"
          control={
            <Checkbox
              name="dashboard_visible"
              checked={!!clientDetailsValues?.dashboard_visible}
              onChange={() => {
                setClientDetailsValues((oldState) => ({
                  ...oldState,
                  dashboard_visible: !clientDetailsValues?.dashboard_visible,
                }))
              }}
            />
          }
        />
      </Box>
    )
  }

  const renderDescriptionField = () => {
    return (
      <Box marginTop="8px">
        <CounterHeader
          title="Dashboard Description"
          value={clientDetailsValues?.dashboard_description}
          max={1000}
        />
        <TextField
          size="small"
          fullWidth
          multiline
          rows={10}
          value={clientDetailsValues?.dashboard_description || ""}
          onChange={(e) => {
            setClientDetailsValues((oldState) => ({
              ...oldState,
              dashboard_description: e.target.value,
            }))
          }}
          InputProps={{
            disableUnderline: true,
            classes: {
              root: classes.inputDescription,
            },
          }}
        />
      </Box>
    )
  }

  const renderVideoField = (phoneView) => {
    return (
      <Box width={phoneView ? "100%" : "48%"} marginTop="8px">
        <Typography color="secondary" className={classes.inputLabel}>
          Dashboard Video
        </Typography>
        <CloudinaryVideoUpload
          style={{ marginBottom: "10px" }}
          value={
            clientDetailsValues?.dashboard_video
              ? JSON.parse(clientDetailsValues?.dashboard_video)
              : null
          }
          onUpload={(result) => {
            setClientDetailsValues((oldState) => ({
              ...oldState,
              dashboard_video: getUploadData(result.data),
            }))
          }}
        />
      </Box>
    )
  }

  const renderImageField = (phoneView) => {
    return (
      <Box width={phoneView ? "100%" : "48%"} marginTop="8px">
        <Typography color="secondary" className={classes.inputLabel}>
          Dashboard Image
        </Typography>
        <ThumbnailUpload
          title="Drop image here"
          type="thumbnail"
          cloudinaryUploadPreset={
            import.meta.env.VITE_CLOUDINARY_CLOUD_THUMBNAIL_UPLOAD
          }
          value={
            clientDetailsValues?.dashboard_image
              ? JSON.parse(clientDetailsValues?.dashboard_image)
              : null
          }
          onUpload={(result, setLoading) => {
            setClientDetailsValues((oldState) => ({
              ...oldState,
              dashboard_image: getUploadData(result.data),
            }))
            setLoading(false)
          }}
        />
      </Box>
    )
  }
  return (
    <>
      <Typography variant="h3" color="primary" className={classes.title}>
        Dashboard Details
      </Typography>
      {renderDashboardVisible()}
      {renderDescriptionField()}
      <Box display="flex" justifyContent="space-between" flexWrap="wrap">
        {renderVideoField(phoneView)}
        {renderImageField(phoneView)}
      </Box>
    </>
  )
}

export default DashboardLeftSide
